import type { Reducer } from 'redux';
import type { CreditAppState } from '@makemydeal/dr-sales-checkin-store';
import { CreditAppStatus } from '@makemydeal/dr-sales-checkin-types';
import { initialCreditAppState } from './initialState';
import { SUBMIT_CREDIT_APP, INITIALIZE_CREDIT_APP, RESET_CREDIT_APP } from './actions';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';

export const creditAppReducer: Reducer<CreditAppState> = (
    state: CreditAppState = initialCreditAppState,
    action: AnyFSA
): CreditAppState => {
    const { payload, type } = action;

    switch (type) {
        case INITIALIZE_CREDIT_APP: {
            const creditAppData = payload?.creditApp;
            return {
                status: creditAppData?.status || null,
                creditAppId: creditAppData?.creditAppId || null,
                dealRefId: creditAppData?.dealRefId || payload?.dealRefId || null,
                shopper: creditAppData?.shopper || null
            };
        }
        case SUBMIT_CREDIT_APP: {
            return {
                ...state,
                status: CreditAppStatus.SUBMITTED,
                creditAppId: payload?.creditAppId || state.creditAppId,
                dealRefId: payload?.dealRefId || null,
                shopper: payload?.shopper || null
            };
        }
        case RESET_CREDIT_APP: {
            return initialCreditAppState;
        }
        default:
            return state;
    }
};
